import React, { useState } from "react";
import NavGeneral from "./NavGeneral";
import FooterGeneral from "./FooterGeneral";
import General1 from "./General1";
// import General2 from "./General2";
// import General3 from "./General3";
// import General4 from "./General4";
// import General5 from "./General5";
// import General6 from "./General6";
// import General7 from "./General7";
// import General8 from "./General8";
import arrowDown from "../../assets/svg/icon-down-left-arrow.svg";

import ResizeHandler from "../../ResizeHandler";
import { Panel,PanelGroup } from "react-resizable-panels";
import '../../css/resizable.css';

const General = () => {
  const [inputValue, setInputValue] = useState("");

  return (
    <section className="general">
      <NavGeneral />
      <div className="generalLine">
        <div className="inner-container">
          <select name="start">
            <option
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
            >
              Начало
            </option>
            <option
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
            >
              Option2
            </option>
            <option
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
            >
              Option3
            </option>
          </select>
          <label htmlFor="start">
            <img src={arrowDown} alt="ArrowDown" />
          </label>
        </div>
      </div>
      <div className="Container">
        <div className="container-inner">
        <PanelGroup autoSaveId="generalVerticalGroup" direction="vertical">
          <Panel>
            <General1 />
          </Panel>
          <ResizeHandler className="resize-div-wrapper rotated"/>
        <Panel>
          <FooterGeneral />
        </Panel>
        </PanelGroup>
        </div>
      </div>
    </section>
  );
};

export default General;
